import React from 'react';

const GuestLoginRequiredModal = ({
  show,
  onClose,
  onContinue,
  title = 'Login required',
  message = 'You are browsing as a guest. Please login to add products to your cart.',
}) => {
  if (!show) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          background: '#fff',
          borderRadius: 20,
          padding: 24,
          boxShadow: '0 18px 45px rgba(0,0,0,0.18)',
          textAlign: 'center',
        }}
      >
        <h3 style={{ marginBottom: 12, fontSize: 22 }}>{title}</h3>
        <p style={{ marginBottom: 24, color: '#4b5563' }}>
          {message}
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              minWidth: 110,
              padding: '10px 16px',
              borderRadius: 10,
              border: '1px solid #d1d5db',
              background: '#ffffff',
              color: '#111827',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onContinue}
            style={{
              minWidth: 110,
              padding: '10px 16px',
              borderRadius: 10,
              border: 'none',
              background: '#2563eb',
              color: '#ffffff',
              cursor: 'pointer',
            }}
          >
            Login Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestLoginRequiredModal;
